<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17CuU3u/images/Cover.jpg?1708005252229" alt="This image is the cover for the book Haunted Central New York, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Central New York, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Discover the spooky history of New York's central region</strong></p><p>From the edge of the Adirondacks, to the heart of Syracuse and everything in between, central New York boasts some of the most haunted history in the state. Utica, Rome and Cazenovia all have historic tales of ghostly moments and unexplained aparations. Join author Dennis Webster as he reveals the hidden haunted history of central New York.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dennis Webster
      </h2>
      
      <p class="authorDescription body article">Dennis Webster is a ghost hunter and paranormal investigator with the Ghost Seekers of Central New York. He has walked haunted churches, theaters, temples and graveyards. He's the published author of Haunted Adirondacks , Haunted Utica , Haunted Old Forge and Haunted Mohawk Valley . He's written books on true crime and lunatic asylums. He has a Bachelor of Science degree from Utica University and a Master of Business Administration (MBA) degree from the State University of New York Polytechnic. He can be reached by email at denniswbstr@gmail.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16d69ed2